import SurveyForm from "../components/SurveyForm";

const CreateCustomSurveyPage = () => <SurveyForm mode="custom" />;

export default CreateCustomSurveyPage;
